import { useEffect } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { getDetailPlace, getYellowPagesImages } from "../../features/yellowPages/yellowPagesSlice"
import { useSelector } from "react-redux"


const Container = styled.div`
position: absolute;
top: 40px;
left: 40px;
width: 400px;
height: 90%;
background-color: rebeccapurple;
border-radius: 10px;
    
`
const IsletmeDetails = ({}) => {

  const disaptch = useDispatch()

  const {isletmeImages} = useSelector(state => state.yellowPages)


  useEffect(() => {
    // disaptch(getYellowPagesImages())
  },[])


  return (
    <Container>
<img src={isletmeImages} alt="" />
    </Container>
  )
}

export default IsletmeDetails